import { Checkbox } from "Components/Form/Checkbox";
import { useTexts } from "Components/TextContext";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";

interface Props {
  formProps: FormikProps<any>;
}

export const CoopConsent = ({ formProps }: Props): React.ReactElement => {
  const { getText } = useTexts();

  return (
    <Checkbox
      id="coopConsent"
      name="coopConsent"
      label={getText("partnercoop.label.consent")}
      hint={getText("partnercoop.hint.consent")}
      error={getError("coopConsent", formProps)}
      errorTitle={getText("partnercommon.validation.mandatoryconsent_header")}
    />
  );
};
